import { useEffect, useRef, useState } from 'react';
import { getWindowMetrics } from '../utils/getWindowMetrics';
const emptyRect = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  width: 0,
  height: 0
};
export function useBoundingRects(isWindow) {
  if (isWindow === void 0) {
    isWindow = true;
  }
  const [rect, setRect] = useState(emptyRect);
  const [parentRect, setParentRect] = useState(emptyRect);
  const nodeRef = useRef(null);
  useEffect(() => {
    const node = nodeRef.current;
    if (node) {
      const calculateRects = () => {
        const rect = node.getBoundingClientRect();
        const parent = node.parentNode;
        let parentRect;
        if (isWindow) {
          parentRect = getWindowMetrics();
        } else if (parent) {
          parentRect = parent.getBoundingClientRect();
        } else {
          parentRect = emptyRect;
        }
        setRect(rect);
        setParentRect(parentRect);
      };
      calculateRects();
    }
  }, [nodeRef, setRect, setParentRect]);
  return {
    nodeRef,
    rect,
    parentRect
  };
}